'use client';

import { useContext } from 'react';
import { useSettings } from '@/providers/settings-provider';
import { OrganisationThemeContext } from '@/providers/organisation-theme-provider';

export const DEFAULT_BACKGROUND = 'particles';

/**
 * Wirksame Hintergrund-Animation:
 *   1. eigene Wahl des Benutzers (localStorage, settings.ui.backgroundAnimation)
 *   2. Firmen-Standard (organisation_themes.custom_variables.background_animation,
 *      wird auch von Firmen-Vorlagen gesetzt)
 *   3. 'particles'
 */
export function useEffectiveBackground() {
  const { settings } = useSettings();
  const themeCtx = useContext(OrganisationThemeContext);
  const own = settings?.ui?.backgroundAnimation ?? null;
  const orgDefault = themeCtx?.theme?.advanced?.customVariables?.background_animation ?? null;
  return {
    bgKey: own ?? orgDefault ?? DEFAULT_BACKGROUND,
    own,
    orgDefault,
    themeCtx,
  };
}
